/**
 * coverState.js — F-87 / COVER-PHOTO-1.
 *
 * The single source of truth for deriving a book's cover-photo builder state. App.js holds cover-photo state
 * as SHARED state (one set of stBookCoverPhoto* values reused across books), so EVERY book-load path
 * (enterBook, onFirstBookLoaded, openMyBook) must reset that state from THIS helper — unconditionally,
 * including null for a photo-less book. A guarded set ("if the book has a photo, set it") leaves a sibling's
 * photo in the shared state, which then renders on and auto-saves onto a photo-less book (the production
 * bleed). Pure + testable.
 */
export function coverPhotoStateFromBook(book) {
  return {
    coverPhotoPath: (book && book.coverPhotoPath) || null,
    coverPhotoY: (book && book.coverPhotoY != null) ? book.coverPhotoY : 50,
    coverPhotoOrientation: (book && book.coverPhotoOrientation) || 'landscape',
    coverPhotoTone: (book && book.coverPhotoTone) || 'color',
  };
}

/**
 * Autosave belt (the critical bleed-persist guard): decide which coverPhotoPath is safe to write onto the
 * active book. If the in-session state path belongs to a DIFFERENT book in the account (a bleed from the
 * shared state), fall back to THIS book's own record path — never persist a sibling's photo. A real upload
 * writes a fresh, unique path that no sibling owns, so it passes through untouched.
 */
export function resolveCoverPhotoToSave(activeBookId, statePhotoPath, books) {
  const list = Array.isArray(books) ? books : [];
  const own = list.find((b) => b.id === activeBookId)?.coverPhotoPath ?? null;
  const isSiblingPath = !!statePhotoPath && statePhotoPath !== own
    && list.some((b) => b.id !== activeBookId && b.coverPhotoPath === statePhotoPath);
  return isSiblingPath ? own : statePhotoPath;
}
